/**
 * @generated SignedSource<<c96e5bb5f59db8e81facf773cabc7cfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentOverview_GetContentOverviewQuery$variables = {
  id: string;
};
export type contentOverview_GetContentOverviewQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"contentOverview_LearnOpportunityV2Fragment">;
  } | null;
};
export type contentOverview_GetContentOverviewQuery = {
  response: contentOverview_GetContentOverviewQuery$data;
  variables: contentOverview_GetContentOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "indexPath",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "structureDefinition",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentKind",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receivableGamificationPoints",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receivedGamificationPoints",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "file",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v5/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lengthInSecondsV2",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUnlockNecessaryToStart",
          "storageKey": null
        }
      ],
      "type": "LearnContentExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contentOverview_GetContentOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "contentOverview_LearnOpportunityV2Fragment"
              }
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentOverview_GetContentOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InstructorsConnection",
                "kind": "LinkedField",
                "name": "instructorsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstructorsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isInstructor"
                          },
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v8/*: any*/)
                            ],
                            "type": "InstructorImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "typeDefinition",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ElementsSummary",
                                "kind": "LinkedField",
                                "name": "elementsSummary",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numFileElements",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sumTextLengthInSec",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sumVideoLengthInSec",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sumPodcastWithTimestampLengthInSec",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numExerciseElements",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnContentExtensionImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "LearnOpportunityELearningContentTypeDefinition",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/)
                            ],
                            "type": "LearnContentExtensionImpl",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "elementKind",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAsyncElementTask"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v17/*: any*/),
                            "type": "FreshUploadAsyncElementTask",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UploadEvaluation",
                                "kind": "LinkedField",
                                "name": "evaluation",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "EvaluatedUploadAsyncElementTask",
                            "abstractKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taskDescription",
                        "storageKey": null
                      }
                    ],
                    "type": "LearnAsyncContentTypeDefinition",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnOpportunityV2",
                "kind": "LinkedField",
                "name": "root",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "structureDefinition",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReducedData",
                                    "kind": "LinkedField",
                                    "name": "reducedData",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isIHK",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ihkState",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "unlockInfo",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v18/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "firstContentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "firstContentCoordinatesIndexPath",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UnlockInfoDemo",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedRootExtensionImpl",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "viewerTreeState",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "headContentId",
                                    "storageKey": null
                                  }
                                ],
                                "type": "IsStartedViewerTreeState",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityRootStructureDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "typeDefinition",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnOpportunityV2",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "typeDefinition",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LearnOpportunityV2",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v8/*: any*/),
                                          (v6/*: any*/),
                                          (v11/*: any*/),
                                          (v9/*: any*/),
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "typeDefinition",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v12/*: any*/),
                                                  (v20/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "task",
                                                    "plural": false,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      (v15/*: any*/),
                                                      (v4/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "LearnAsyncContentTypeDefinition",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v12/*: any*/),
                                                  (v20/*: any*/)
                                                ],
                                                "type": "LearnOpportunityELearningContentTypeDefinition",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LearnOpportunityBranchTypeDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnOpportunityBranchTypeDefinition",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "attachmentsV2",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "FileAttachment",
                    "abstractKey": "__isFileAttachment"
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityV2",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b8efac922c2943aaa4655ce21e40612",
    "id": null,
    "metadata": {},
    "name": "contentOverview_GetContentOverviewQuery",
    "operationKind": "query",
    "text": "query contentOverview_GetContentOverviewQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on LearnOpportunityV2 {\n      ...contentOverview_LearnOpportunityV2Fragment\n    }\n    id\n  }\n}\n\nfragment AttachmentsCollection_AttachmentsCollectionFragment on LearnOpportunityV2 {\n  indexPath\n  attachmentsV2 {\n    __typename\n    title\n    ... on FileAttachment {\n      __isFileAttachment: __typename\n      file {\n        url\n        name\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment UploadAsyncContentOverview_AsyncElementTaskFragment on AsyncElementTask {\n  __isAsyncElementTask: __typename\n  status\n  ... on FreshUploadAsyncElementTask {\n    file {\n      url\n      name\n      id\n    }\n  }\n  ... on EvaluatedUploadAsyncElementTask {\n    file {\n      url\n      name\n      id\n    }\n    evaluation {\n      file {\n        url\n        name\n        id\n      }\n      text\n    }\n  }\n}\n\nfragment asyncContentOverview_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnAsyncContentTypeDefinition {\n      task {\n        __typename\n        status\n        elementKind\n        ...UploadAsyncContentOverview_AsyncElementTaskFragment\n        id\n      }\n      taskDescription\n    }\n  }\n  attachmentsV2 {\n    __typename\n    id\n  }\n  indexPath\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        viewerTreeState {\n          __typename\n          kind\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n        extension {\n          __typename\n          ... on PublishedRootExtensionImpl {\n            unlockInfo {\n              __typename\n              kind\n              ... on UnlockInfoDemo {\n                firstContentId\n              }\n            }\n          }\n        }\n      }\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          typeDefinition {\n            __typename\n            ... on LearnOpportunityBranchTypeDefinition {\n              children {\n                id\n                indexPath\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  ...AttachmentsCollection_AttachmentsCollectionFragment\n}\n\nfragment branchNodesTab_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          reducedData {\n            isIHK\n          }\n          ihkState\n        }\n      }\n    }\n  }\n  ...branchNodesTree_LearnOpportunityV2Fragment\n}\n\nfragment branchNodesTree_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityBranchTypeDefinition {\n      children {\n        id\n        image {\n          url\n          id\n        }\n        structureDefinition {\n          __typename\n          title\n        }\n        indexPath\n        typeDefinition {\n          __typename\n          ... on LearnOpportunityBranchTypeDefinition {\n            children {\n              id\n              image {\n                url\n                id\n              }\n              shortDescription\n              structureDefinition {\n                __typename\n                title\n              }\n              indexPath\n              lengthInSecondsV2\n              ...contentCard_LearnOpportunityV2Fragment\n            }\n          }\n        }\n      }\n    }\n  }\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      viewerTreeState {\n        __typename\n        kind\n        ... on IsStartedViewerTreeState {\n          headContentId\n        }\n      }\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          unlockInfo {\n            __typename\n            kind\n            ... on UnlockInfoDemo {\n              firstContentId\n              firstContentCoordinatesIndexPath\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment contentCard_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  image {\n    url\n    id\n  }\n  shortDescription\n  structureDefinition {\n    __typename\n    title\n  }\n  indexPath\n  lengthInSecondsV2\n  typeDefinition {\n    __typename\n    ... on LearnAsyncContentTypeDefinition {\n      contentKind\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          receivableGamificationPoints\n          receivedGamificationPoints\n          isUnlockNecessaryToStart\n        }\n      }\n      task {\n        __typename\n        status\n        id\n      }\n    }\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentKind\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          receivableGamificationPoints\n          receivedGamificationPoints\n          isUnlockNecessaryToStart\n        }\n      }\n    }\n  }\n}\n\nfragment contentElementsCollection_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          elementsSummary {\n            numFileElements\n            sumTextLengthInSec\n            sumVideoLengthInSec\n            sumPodcastWithTimestampLengthInSec\n            numExerciseElements\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment contentOverview_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  description\n  instructorsV2 {\n    ...instructorsComponent_InstructorsConnectionFragment\n  }\n  indexPath\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    ... on LearnOpportunityELearningContentTypeDefinition {\n      contentKind\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          receivableGamificationPoints\n          receivedGamificationPoints\n        }\n      }\n    }\n    ... on LearnAsyncContentTypeDefinition {\n      contentKind\n      extension {\n        __typename\n        ... on LearnContentExtensionImpl {\n          receivableGamificationPoints\n          receivedGamificationPoints\n        }\n      }\n    }\n  }\n  image {\n    url\n    id\n  }\n  root {\n    ...branchNodesTab_LearnOpportunityV2Fragment\n    id\n  }\n  lengthInSecondsV2\n  ...AttachmentsCollection_AttachmentsCollectionFragment\n  ...contentElementsCollection_LearnOpportunityV2Fragment\n  ...eLearningContentOverview_LearnOpportunityV2Fragment\n  ...asyncContentOverview_LearnOpportunityV2Fragment\n}\n\nfragment eLearningContentOverview_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  instructorsV2 {\n    ...instructorsComponent_InstructorsConnectionFragment\n  }\n  indexPath\n  ...AttachmentsCollection_AttachmentsCollectionFragment\n  ...contentElementsCollection_LearnOpportunityV2Fragment\n  attachmentsV2 {\n    __typename\n    id\n  }\n  root {\n    structureDefinition {\n      __typename\n      ... on LearnOpportunityRootStructureDefinition {\n        viewerTreeState {\n          __typename\n          kind\n          ... on IsStartedViewerTreeState {\n            headContentId\n          }\n        }\n        extension {\n          __typename\n          ... on PublishedRootExtensionImpl {\n            unlockInfo {\n              __typename\n              kind\n              ... on UnlockInfoDemo {\n                firstContentId\n              }\n            }\n          }\n        }\n      }\n    }\n    typeDefinition {\n      __typename\n      ... on LearnOpportunityBranchTypeDefinition {\n        children {\n          typeDefinition {\n            __typename\n            ... on LearnOpportunityBranchTypeDefinition {\n              children {\n                id\n                indexPath\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment instructorAbout_InstructorFragment on Instructor {\n  __isInstructor: __typename\n  name\n  ... on InstructorImpl {\n    description\n    shortDescription\n    image {\n      url\n      id\n    }\n  }\n}\n\nfragment instructorsComponent_InstructorsConnectionFragment on InstructorsConnection {\n  edges {\n    node {\n      __typename\n      id\n      ...instructorAbout_InstructorFragment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9b658e7312e514feb80a512c002892b";

export default node;
